import { createAction, createSlice } from "@reduxjs/toolkit";
import { cloneDeep, remove } from "lodash";

// export const stSetTotalCount = createAction('ST_SET_TOTAL_COUNT');
// export const stSetSkip = createAction('ST_SET_SKIP');
// export const stSetLimit = createAction('ST_SET_LIMIT');
// export const stSetPage = createAction('ST_SET_PAGE');
// export const stSetSort = createAction('ST_SET_SORT');
// export const stSetQuery = createAction('ST_SET_QUERY');
// export const stSetStudents = createAction('ST_SET_STUDENTS');
// export const stReload = createAction('ST_RELOAD');

const initialState = {
  totalCount: 0,
  limit: 20,
  page: 0,
  sort: "created_at DESC",
  query: "",
  nic_status: "",
  status: "",
  students: [],
  error: null,
};

export const slice = createSlice({
  name: "students",
  initialState,
  reducers: {
    stSetTotalCount(state, action) {
      const count = action.payload;
      state.totalCount = count;
    },
    stSetLimit(state, action) {
      state.limit = action.payload;
    },
    stSetPage(state, action) {
      state.page = action.payload;
    },
    stSetSort(state, action) {
      state.sort = action.payload;
    },
    stSetNicStatus(state, action) {
      state.nic_status = action.payload;
      //state.status = '';
    },
    stStatus(state, action) {
      state.status = action.payload;
      //state.nic_status = '';
    },
    stSetQuery: (state, action) => {
      state.query = action.payload;
    },
    stSetStudents(state, action) {
      state.students = [...state.students, ...action.payload];
    },
    stReload(state, action) {
      // ('reload call');
      if (action.payload) {
        state.totalCount = 0;
        // state.limit = 20;
        state.page = 0;
        state.students = [];
        state.error = null;
      }
    },
    updateDelete(state, action) {
      const delete_acc_id = action.payload;
      const cpy = cloneDeep(state.students);
      remove(cpy, (item) => item.account_id === delete_acc_id);
      state.students = cpy;
      state.totalCount = state.totalCount - 1;
    },
  },
});

export const reducer = slice.reducer;
